import { render, staticRenderFns } from "./DBuilderPublishConfirmedPopup.vue?vue&type=template&id=d4734aac&scoped=true&"
import script from "./DBuilderPublishConfirmedPopup.vue?vue&type=script&lang=js&"
export * from "./DBuilderPublishConfirmedPopup.vue?vue&type=script&lang=js&"
import style0 from "./DBuilderPublishConfirmedPopup.vue?vue&type=style&index=0&id=d4734aac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4734aac",
  null
  
)

export default component.exports